import styled from '@emotion/styled'
import { MarketPlaceProperties } from '@pubstack/common/src/bidderCatalog'
import { FunctionComponent } from 'react'
import { Colors } from '~/assets/style/colors'
import { Fonts } from '~/assets/style/fonts'
import { Icon } from '~/components/Icon'
import { Link } from '~/components/Link'
import { Tooltip } from '~/components/Tooltip'

const LegalInfos = styled.div`
  display: flex;
  gap: 90px;
  ${Fonts.P2}
`

const InfoTitle = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 4px;
  gap: 4px;
  color: ${Colors.SlateGrey};
  & ${Tooltip} {
    height: 16px; /*Black magic the tooltip do not center content*/
  }
`

const Status = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`
const Bloc = styled.div`
  padding-bottom: 20px;
  align-items: center;
  p { 
    ${Fonts.P1}
  }
  h2 {
    ${Fonts.H2}
    font-weight: 500;
    padding-bottom: 12px;
  }
`

const LegalLinks = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: column;
`

export const LegalInformation: FunctionComponent<{ marketplaceProperties: MarketPlaceProperties }> = ({ marketplaceProperties }) => {
  return (
    <div>
      <div>
        <strong>Processing description:</strong> {marketplaceProperties.legalInformation.processingDescription}
      </div>
      <div>
        <strong>Existence of transfer outside the EU:</strong> {marketplaceProperties.legalInformation.transferOutsideEU}
      </div>
      <div>
        <strong>Use of TCF:</strong> {marketplaceProperties.legalInformation.TCF}
      </div>
      <div>
        <strong>Restriction on data reuse:</strong> {marketplaceProperties.legalInformation.restrictionDataReuse}
      </div>
      <div>
        <strong>DPO contact:</strong> {marketplaceProperties.legalInformation.DpoContact}
      </div>
    </div>
  )
}

const UnstyledPureMarketplaceLegalInfos: FunctionComponent<{ marketplaceProperties: MarketPlaceProperties; bidderCode: string; onLegalInfosClick: () => void }> = ({
  marketplaceProperties,
  bidderCode,
  onLegalInfosClick,
}) => {
  return (
    <>
      <Bloc>
        <LegalInfos>
          <div>
            <InfoTitle>
              DSA Compatible
              <Tooltip title={'Digital Service Act : European legislation that regulates online intermediaries and platforms, including marketplaces.'}>
                <Icon name={'info'} width={'16px'} height={'16px'} fill={Colors.Hurricane} />
              </Tooltip>
            </InfoTitle>
            <div>
              {marketplaceProperties.dsaCompatible ? (
                <Status>
                  <Icon name={'check_circled'} width={'16px'} fill={Colors.Success} />
                  Yes{' '}
                </Status>
              ) : (
                <Status>
                  <Icon name={'close'} width={'16px'} fill={Colors.Alert} />
                  No{' '}
                </Status>
              )}
            </div>
          </div>
          <div>
            <InfoTitle>GDPR qualification</InfoTitle>
            <div>{marketplaceProperties.gdprQualification}</div>
          </div>
        </LegalInfos>
      </Bloc>
      <LegalLinks>
        <Link label={'Legal information'} onClick={onLegalInfosClick} trackingLabel={`marketplace-legal-information-${bidderCode}-view`} />
        <Link
          icon={'open_in_new'}
          href={marketplaceProperties.privacyPolicies}
          target={'_blank'}
          rel={'noreferrer'}
          label={'Privacy Policies'}
          trackingLabel={`marketplace-privacy-policies-${bidderCode}-navigate`}
        />
        {marketplaceProperties.termsAndConditions !== 'confidential' ? (
          <Link
            icon={'open_in_new'}
            href={marketplaceProperties.termsAndConditions}
            target={'_blank'}
            rel={'noreferrer'}
            label={'Terms & conditions'}
            trackingLabel={`marketplace-terms-and-conditions-${bidderCode}-navigate`}
          />
        ) : (
          <Tooltip title={'confidential - available on demand'}>Terms & conditions</Tooltip>
        )}
        {marketplaceProperties.dpa !== 'confidential' ? (
          <Link icon={'open_in_new'} href={marketplaceProperties.dpa} target={'_blank'} rel={'noreferrer'} label={'DPA'} trackingLabel={`marketplace-dpa-${bidderCode}-navigate`} />
        ) : (
          <Tooltip title={'confidential - available on demand'}>DPA</Tooltip>
        )}
      </LegalLinks>
    </>
  )
}

export const PureMarketplaceLegalInfos = styled(UnstyledPureMarketplaceLegalInfos)``
